export default __webpack_public_path__ + "static/media/guestbook-header.32bb5f99.png";